// extracted by mini-css-extract-plugin
export default {"container":"CmsTransactionList_container__+HXnL","title":"CmsTransactionList_title__e9DeD","tableWrapper":"CmsTransactionList_tableWrapper__J4dfN"};